import axiosInstance from "../../../../../Services/Global-Services/UnauthorizedTokenHandler";
import { getHeaders,checkStatus } from "../../../../../Services/SharedSevices/SharedServices";
const baseURL = process.env.REACT_APP_BASE_URL;
 
 
// For fetching the record of Employee service.
export const getRecruitmentDashboard = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Dashboard`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
export const getTalentRequestList = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/TalentRequest/List`, params,{
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
 
// For fetching the record of Employee Dashboard Count.
export const postTalentRequestSave = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/TalentRequest/Save`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
// For Add Employee Data.
export const postTalentRequestApprove = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/TalentRequest/Approve`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
//Get Employee manager Name
export const deleteRecruitment = async (body) => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Recruitment/TalentRequest/Delete`, body,{
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
//Get Employee Keys Data.
export const getJobList = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Job/List`, body,{
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
// For bulk upload excel file.
export const postJobSave = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Job/Save`,body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
export const postJobStatus = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Job/Status/Update`,body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
export const getEmployeeID = async (params) => {    
  try {
    const response = await axiosInstance.get(`${baseURL}/Recruitment/Job/Delete`, params,{
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
//Bulk Update Employee
export const getCandidateList = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Candidate/List`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
// Bulk welcome mail send for User.
export const postAddCandidate = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Candidate/Save`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
// Bulk welcome mail send for User.
export const postCandidateUpload = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Candidate/Upload`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
// Bulk welcome mail send for User.
export const CandidateDelete = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Candidate/Delete`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
 
// Bulk welcome mail send for User.
export const CandidateExperienceSave = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Candidate/Experience/Save`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
 
// Bulk welcome mail send for User.
export const CandidateExperienceDelete = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Candidate/Experience/Delete`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
// Bulk welcome mail send for User.
export const CandidateEducationSave = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Candidate/Education/Save`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
export const CandidateEducationDelete = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Candidate/Education/Delete`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
export const CandidateNoteAdd = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Candidate/Note/Add`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
export const CandidateNoteDelete = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Candidate/Note/Delete`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
export const CandidateCandidatureSave = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Candidature/Save`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
export const CandidateCandidatureDelete = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Candidature/Delete`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
export const InterviewSave = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Interview/Save`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
export const InterviewFeedbackSave = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Interview/Feedback/Save`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
export const InterviewStatusUpdate = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Interview/Status/Update`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
export const InterviewDelete = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Interview/Delete`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
export const OfferSave = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Offer/Save`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
export const OfferStatusUpdate = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Offer/Status/Update`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
export const OfferDelete = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Offer/Delete`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
export const CandidateHire = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Recruitment/Candidate/Hire`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
 